import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import api from './api'
import { setStore } from './api/request'

Vue.config.productionTip = false
Vue.prototype.$api = api
setStore(store)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
